import { footerCols } from "@/mocks/homeData";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-accent-100/40">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.3fr_2fr]">
          {/* Brand + blurb */}
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500">
                <i className="ri-flashlight-fill text-base text-background-50" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料站</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              聚合商业、消费、娱乐、科技与职场议题的独立内容站点，以频道、分区、专题、板块、栏目与目录承载，
              用求证与复盘支撑每一次围观。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3 text-foreground-500">
              <span className="flex items-center gap-1.5 text-xs">
                <i className="ri-shield-check-line text-primary-600" aria-hidden="true" />
                坚持事实核查
              </span>
              <span className="flex items-center gap-1.5 text-xs">
                <i className="ri-refresh-line text-primary-600" aria-hidden="true" />
                持续更新中
              </span>
            </div>
          </div>

          {/* Columns */}
          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3">
            {footerCols.map((c) => (
              <div key={c.title}>
                <h4 className="mb-3 text-sm font-semibold text-foreground-950">{c.title}</h4>
                <ul className="space-y-2">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a
                        href="#top"
                        className="text-[13px] text-foreground-500 transition-colors hover:text-foreground-950"
                      >
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 text-xs text-foreground-400 sm:flex-row">
          <p>© {new Date().getFullYear()} 黑料站 · 内容仅供参考，请理性看待</p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#top" className="hover:text-foreground-600">内容准则</a>
            <a href="#top" className="hover:text-foreground-600">线索征集</a>
            <a href="#top" className="hover:text-foreground-600">意见反馈</a>
          </div>
        </div>
      </div>
    </footer>
  );
}